<template>
    <div class="mx-auto">
        <b-modal
                ref="modal-devedor"
                id="modal-devedor"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Atualizar Cadastro do Devedor"
                header-bg-variant="success"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <div id="messages" v-if="messageModal.message !== null">
                        <b-alert show :variant="messageModal.variant">{{ messageModal.message }}</b-alert>
                    </div>
                </b-col>
                <b-col xs="12" md="12" class="mx-auto">
                    <b-card>
                        <b-row class="mt-1 mb-0">
                            <b-col sm="12" md="3">
                                <b-form-group
                                        label="CPF / CNPJ:"
                                        label-for="cpf"
                                        class="text-label required">
                                    <b-form-input
                                            type="text"
                                            id="num-documento"
                                            data-vv-as="CPF"
                                            v-model="contribuinte.documento"
                                            v-mask="['###.###.###-##', '##.###.###/####-##']"
                                            description="Somente os números"
                                            :disabled="true"
                                            @change="permitirSalvar = true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="2" md="5">
                                <b-form-group
                                        label="Nome:"
                                        label-for="nome"
                                        class="text-label required">
                                    <b-form-input v-model="contribuinte.nome" type="text" id="nome" maxlength="100"
                                                  @keyup="contribuinte.nome = removeSpecialCharacters(contribuinte.nome)"
                                                  @change="permitirSalvar = true"
                                                  :class="'text-label required ' + (!paymentValidations.nome.valid ? 'is-invalid' : '')"
                                    />
                                    <b-row>
                                    <b-col sm="12" md="12">
                                    <div v-if="!paymentValidations.nome.valid" class="invalid-message">Campo Obrigatório.</div>
                                   </b-col>
                                   </b-row> 
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>
                    <b-card title="Endereço">
                        <b-row>
                            <b-col sm="2" md="3">
                                <b-form-group
                                        label="CEP:"
                                        label-for="cep"
                                        class="text-label">
                                    <b-form-input
                                            type="text"
                                            id="cep"
                                            data-vv-as="cep"
                                            v-model="contribuinte.cep"
                                            v-mask="['#####-###']"
                                            description="Somente os números"
                                            @change="obterEnderecoPorCep();permitirSalvar = true;"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="2" md="5">
                                <b-form-group
                                        label="Logradouro:"
                                        label-for="logradouro"
                                        class="text-label">
                                    <b-form-input v-model="contribuinte.logradouro" type="text" id="logradouro" maxlength="100"
                                                  @keyup="contribuinte.logradouro = removeSpecialCharactersGeral(contribuinte.logradouro)"
                                                  @change="permitirSalvar = true"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="2">
                                <b-form-group
                                        label="Número:"
                                        label-for="numero"
                                        class="text-label">
                                    <b-form-input v-model="contribuinte.numero" type="text" id="numero" maxlength="100"
                                                  @keyup="contribuinte.numero = removeSpecialCharactersGeral(contribuinte.numero)"
                                                  @change="permitirSalvar = true"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-1 mb-0">
                            <b-col sm="12" md="3">
                                <b-form-group
                                        label="Complemento:"
                                        label-for="complemento"
                                        class="text-label">
                                    <b-form-input v-model="contribuinte.complemento" type="text" id="complemento" maxlength="50"
                                                  @keyup="contribuinte.complemento = removeSpecialCharactersGeral(contribuinte.complemento)"
                                                  @change="permitirSalvar = true"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="5">
                                <b-form-group
                                        label="Bairro:"
                                        label-for="bairro"
                                        class="text-label">
                                    <b-form-input v-model="contribuinte.bairro" type="text" id="bairro" maxlength="50"
                                                  @keyup="contribuinte.bairro = removeSpecialCharactersGeral(contribuinte.bairro)"
                                                  @change="permitirSalvar = true"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-1 mb-0">
                            <b-col sm="12" md="3">
                                <b-form-group label="UF:" label-for="uf" class="text-label">
                                    <multiselect
                                            class="multiselect-simple"
                                            name="uf"
                                            v-model="contribuinte.uf"
                                            :show-labels="false"
                                            :options="dados.uf"
                                            :multiple="false"
                                            :close-on-select="true"
                                            :clear-on-select="true"
                                            :preserve-search="false"
                                            placeholder="Selecione"
                                            track-by="nome"
                                            label="nome"
                                            @input="listarMunicipios();permitirSalvar = true;">
                                        <template v-slot:first>
                                            <option :value="null">Selecionar</option>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="5">
                                <b-form-group label="Município:" label-for="municipio" class="text-label">
                                    <multiselect
                                            class="multiselect-simple"
                                            name="municipio"
                                            v-model="contribuinte.municipio"
                                            :show-labels="false"
                                            :options="dados.municipios"
                                            :multiple="false"
                                            :close-on-select="true"
                                            :clear-on-select="true"
                                            :preserve-search="false"
                                            placeholder="Selecione"
                                            track-by="codMunicipio"
                                            label="nome"
                                            @input="permitirSalvar = true"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>
                    <b-card title="Contato">
                        <b-row>
                            <b-col sm="12" md="4">
                                <b-form-group
                                        label="Telefone/Celular:"
                                        label-for="telefone"
                                        class="text-label">
                                    <b-form-input
                                            type="text"
                                            id="telefone"
                                            data-vv-as="telefone"
                                            v-model="contribuinte.telefone"
                                            v-mask="['(##) #####-####', '(##) ####-####']"
                                            description="Somente os números"
                                            @change="permitirSalvar = true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4">
                                <b-form-group
                                        label="Telefone Alternativo 1:"
                                        label-for="telefoneAlternativo1"
                                        class="text-label">
                                    <b-form-input
                                            type="text"
                                            id="telefoneAlternativo1"
                                            data-vv-as="telefoneAlternativo1"
                                            v-model="contribuinte.telefoneAlternativo1"
                                            v-mask="['(##) #####-####', '(##) ####-####']"
                                            description="Somente os números"
                                            @change="permitirSalvar = true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4">
                                <b-form-group
                                        label="Telefone Alternativo 2:"
                                        label-for="telefoneAlternativo2"
                                        class="text-label">
                                    <b-form-input
                                            type="text"
                                            id="telefoneAlternativo2"
                                            data-vv-as="telefoneAlternativo2"
                                            v-model="contribuinte.telefoneAlternativo2"
                                            v-mask="['(##) #####-####', '(##) ####-####']"
                                            description="Somente os números"
                                            @change="permitirSalvar = true"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12" md="4">
                                <b-form-group
                                        label="E-mail principal:"
                                        label-for="email"
                                        class="text-label"
                                        :class="showEmailError() ? 'required' : ''">
                                    <b-form-input v-model="contribuinte.email" type="text" id="email" maxlength="100" ref="email"
                                                  @keyup="contribuinte.email = removeSpecialCharactersGeral(contribuinte.email)"
                                                  @change="permitirSalvar = true"
                                                  :class="'text-label required ' + (!paymentValidations.email.valid || showEmailError() ? 'is-invalid' : '')"
                                    />
                                    <b-row>
                                        <b-col sm="12" md="12">
                                            <div v-if="!paymentValidations.email.valid || showEmailError()" class="invalid-message">Campo Obrigatório.</div>
                                        </b-col>
                                    </b-row> 
                                    <div v-if="!validations.email.valid" class="invalid-message">E-mail inválido!</div>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4">
                                <b-form-group
                                        label="E-mail alternativo 1:"
                                        label-for="emailAlternativo1"
                                        class="text-label">
                                    <b-form-input v-model="contribuinte.emailAlternativo1" type="text" id="emailAlternativo1" maxlength="100" ref="emailAlternativo1"
                                                  @keyup="contribuinte.emailAlternativo1 = removeSpecialCharactersGeral(contribuinte.emailAlternativo1)"
                                                  :class="!validations.emailAlternativo1.valid ? 'is-invalid' : ''"
                                                  @change="permitirSalvar = true"/>
                                    <div v-if="!validations.emailAlternativo1.valid" class="invalid-message">E-mail inválido!</div>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4">
                                <b-form-group
                                        label="E-mail alternativo 2:"
                                        label-for="emailAlternativo2"
                                        class="text-label">
                                    <b-form-input v-model="contribuinte.emailAlternativo2" type="text" id="emailAlternativo2" maxlength="100" ref="emailAlternativo2"
                                                  @keyup="contribuinte.emailAlternativo2 = removeSpecialCharactersGeral(contribuinte.emailAlternativo2)"
                                                  :class="!validations.emailAlternativo2.valid ? 'is-invalid' : ''"
                                                  @change="permitirSalvar = true"/>
                                    <div v-if="!validations.emailAlternativo2.valid" class="invalid-message">E-mail inválido!</div>
                                </b-form-group>
                            </b-col>

                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="limparValidacao  "> <i class="fa fa-times"></i> Cancelar</b-button>
                <b-button variant="primary" @click="validarSalvar" :disabled="!permitirSalvar" class="mr-2"> <i class="far fa-save"></i> Salvar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-salvar-alterar-devedor"
                id="modal-salvar-alterar-devedor"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Salvar"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja salvar as alterações?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-salvar-alterar-devedor')"> Não</b-button>
                <b-button variant="primary" @click="salvarDevedor"> Sim</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';

    export default {
    props: ['loading', 'type'],
    mixins: [ formatarMixins ],
    data() {
        return {
            urlApi: null,
            token: null,
            permitirSalvar: false,
            dados: {
                uf: [],
                municipios: []
            },
            contribuinte: {
                nome: null,
                documento: null,
                telefone: null,
                email: null,
                emailAlternativo1: null,
                emailAlternativo2: null,
                cep: null,
                logradouro: null,
                numero: null,
                complemento: null,
                bairro: null,
                uf: null,
                municipio: null
            },
            messageModal: {
                message: null,
                variant: null
            },
            validations: {
                email: { valid: true },
                emailAlternativo1: { valid: true },
                emailAlternativo2: { valid: true }
            },
            paymentValidations: {
                nome: { valid: true, message: ""},
                email: {valid: true, message: ""}
            },  
        }
    },
    computed: {
        getTheme () {
            return this.$store.getters.getTheme
        }
    },
    methods: {
        // condicoes que tornam a validacao de email obrigatoria
        showEmailError: function () {
            if ((this.contribuinte.email === '' || this.contribuinte.email === null) && (this.type === 'REQUISICAO_EF_SEFA' || this.type === 'HONORARIOS_ACAO_JUDICIAL')) {
                return true;
            }
            return false;
        },
        atualizarCadastro(contribuinteParam) {
            this.contribuinte = {
                codContribuinte: contribuinteParam.codContribuinte,
                nome: contribuinteParam.nome,
                documento: contribuinteParam.documento,
                telefone: contribuinteParam.telefone,
                email: contribuinteParam.email,
                emailAlternativo1: contribuinteParam.emailAlternativo1,
                emailAlternativo2: contribuinteParam.emailAlternativo2,
                telefoneAlternativo1: contribuinteParam.telefoneAlternativo1,
                telefoneAlternativo2: contribuinteParam.telefoneAlternativo2,
                cep: contribuinteParam.cep,
                logradouro: contribuinteParam.logradouro,
                numero: contribuinteParam.numero,
                complemento: contribuinteParam.complemento,
                bairro: contribuinteParam.bairro,
                uf: contribuinteParam.uf,
                municipio: contribuinteParam.municipio
            };

            if(this.contribuinte.uf == null) {
                this.dados.municipios = [];
            } else {
                axios.get(`${this.urlApi}/v1/endereco/listarMunicipios/${this.contribuinte.uf.nome}`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.municipios = response.data;
                })
            }

            this.limparMsgsModal();
            this.permitirSalvar = false;

            this.$refs['modal-devedor'].show();
        },
        carregarCadastro(codContribuinte) {
            this.loading.showLoading();

            axios.get(`${this.urlApi}/v1/contribuinte/obter/` + codContribuinte, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.contribuinte = {
                    ...response.data
                };

                if(this.contribuinte.documento.toString().length <= 11) {
                    this.contribuinte.documento = this.mascaraCpf(this.contribuinte.documento.toString());
                } else {
                    this.contribuinte.documento = this.mascaraCnpj(this.contribuinte.documento.toString());
                }

                if(this.contribuinte.uf == null) {
                    this.dados.municipios = [];
                } else {
                    axios.get(`${this.urlApi}/v1/endereco/listarMunicipios/${this.contribuinte.uf.nome}`, {
                        headers: {
                            'Authorization': this.token
                        }
                    }).then(response => {
                        this.dados.municipios = response.data;
                    });
                }

                this.limparMsgsModal();
                this.permitirSalvar = false;

                this.$refs['modal-devedor'].show();
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            });
        },
        limparMsgsModal() {
            this.messageModal = {
                message: null,
                variant: null
            };
        },
        async listarUfs() {
            axios.get(`${this.urlApi}/v1/endereco/listarUf`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.uf = response.data;
            })
        },
        async listarMunicipios() {
            this.contribuinte.municipio = null;
            if(this.contribuinte.uf == null) {
                this.dados.municipios = [];
            } else {
                axios.get(`${this.urlApi}/v1/endereco/listarMunicipios/${this.contribuinte.uf.nome}`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.dados.municipios = response.data;
                })
            }
        },
        obterEnderecoPorCep() {
            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/endereco/obterEnderecoPorCep/${this.contribuinte.cep}`, '', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.contribuinte.uf = null;
                for(var i = 0; i < this.dados.uf.length; i++) {
                    if(this.dados.uf[i].nome == response.data.uf) {
                        this.contribuinte.uf = this.dados.uf[i];
                    }
                }

                this.listarMunicipios();

                this.contribuinte.municipio = response.data.cidade;
                this.contribuinte.logradouro = response.data.logradouro;
                this.contribuinte.bairro = response.data.bairro;
                this.contribuinte.complemento = response.data.complemento;
            }).finally(() => {
                this.loading.hideLoading();
            })
        },
        validarSalvar() {
        
            if(this.contribuinte.documento.length <= 14 && !this.validarCpf(this.contribuinte.documento)) {
                this.messageModal = {
                    message: 'CPF inválido',
                    variant: 'danger'
                };
                return;
            } else if(this.contribuinte.documento.length > 14 && !this.validarCnpj(this.contribuinte.documento)) {
                this.messageModal = {
                    message: 'CNPJ inválido',
                    variant: 'danger'
                };
                return;
            }

            if(!this.validateEmail(this.contribuinte.email, this.validations.email)
                | !this.validarValorObrigatorio(this.contribuinte.nome)
                | !this.validarValorObrigatorio(this.contribuinte.email)
                | !this.validateEmail(this.contribuinte.emailAlternativo1, this.validations.emailAlternativo1)
                | !this.validateEmail(this.contribuinte.emailAlternativo2, this.validations.emailAlternativo2)) {
                return;
            }

            this.$refs['modal-salvar-alterar-devedor'].show();
        },
        
        
        validarValorObrigatorio() {
                
                if(this.contribuinte.nome == "" | this.contribuinte.nome == null) {
                    
                    this.validarCampoObrigatorio(this.contribuinte.nome, this.paymentValidations.nome)
                    this.limparValidations(this.paymentValidations);
                    return this.paymentValidations.nome.valid=false;

                } else if (this.showEmailError()) {
                    this.validarCampoObrigatorio(this.contribuinte.email, this.paymentValidations.email)
                    this.limparValidations(this.paymentValidations);
                    return this.paymentValidations.email.valid=false;

                } else {
                    this.limparValidations(this.paymentValidations);
                    return this.paymentValidations.nome.valid=true;
                }
                
            },
            
             limparValidacao() {
            
               this.limparValidations(this.paymentValidations);
               this.hideModal('modal-devedor');
            },
        
        salvarDevedor() {
            this.$refs['modal-salvar-alterar-devedor'].hide();

            let devedorBusca = {
                documento: this.contribuinte.documento,
                codContribuinte: this.contribuinte.codContribuinte,
            };

            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/receitasDiversas/obterContribuinte`, devedorBusca, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                if(response.data != null && response.data != "") {
                    this.messageModal = {
                        message: 'CPF/CNPJ já cadastrado no sistema.',
                        variant: 'danger'
                    };
                    this.loading.hideLoading();
                } else {
                    this.$refs['modal-devedor'].hide();
                    axios.post(`${this.urlApi}/v1/contribuinte/salvarModal`, this.contribuinte, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        this.$emit('salvarDevedor', this.contribuinte);
                    }).catch((error) => {
                        this.exibirErro(error)
                    }).finally(() => {
                        this.loading.hideLoading();
                    });
                }
            }).catch((error) => {
                this.exibirErro(error);
                this.loading.hideLoading();
            });
        },
        verificarObrigatoriedade() {
            return !(this.verificarValorVazio(this.contribuinte.nome) ||
                this.verificarValorVazio(this.contribuinte.documento));
        },
        isShow() {
            return this.$refs['modal-devedor'].isShow;
        },
        validarSalvarEnter(e) {
            setTimeout(()=>{
                if(this.$refs['modal-devedor'].isShow && e.key == 'Enter' && this.$refs['modal-salvar-alterar-devedor'] != undefined) {
                    if(this.permitirSalvar) {
                        this.validarSalvar();
                    } else {
                        this.$refs['modal-devedor'].hide();
                    }
                }
            }, 200);
        },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        this.listarUfs();
        setTimeout(()=>{
            window.addEventListener("keypress", this.validarSalvarEnter);
        }, 500);
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
